<!--
 * @Author: your name
 * @Date: 2020-08-12 15:34:29
 * @LastEditTime: 2022-12-07 17:19:29
 * @LastEditors: 逐梦的风很轻 1114532270@qq.com
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/views/Order/index.vue
-->
<style scoped lang="sass">
$noteColor: rgba(51, 68, 85, 1)
$backGroundColor: #f1f2f3
$textWhiteColor: #fff

.van-button__text
  flex-direction: row

.text
  margin-left: 14px

.touched
  color: $textWhiteColor !important
  background: var(--menu-primary-background-colour) !important

  .icon
    color: $textWhiteColor !important

::v-deep
  .order_item
    border-bottom: 1px solid $backGroundColor

  .van-stepper__input
    font-weight: 500

  .van-button__text
    display: flex
    align-items: center

.app_container
  display: flex
  flex-direction: column
  justify-content: space-between

  .min_delivery_amount
    display: flex
    align-items: center
    margin: 0 14px 14px
    padding: 0 10px
    height: 46px
    background: rgba(176, 6, 32, .1)
    border: 1px solid rgba(176, 6, 32, .3)
    border-radius: 4px

    &.green
      background: rgba(6, 163, 65, .05)
      border: 1px solid rgba(6, 163, 65, .25)

      .condition_icon
        margin-right: 10px
        font-size: 20px
        color: #06A341 !important
        transform: rotate(90deg)

      .min_delivery_amount_text
        margin-left: 0

    .min_delivery_amount_icon
      font-size: 26px
      color: #B00620 !important

    .min_delivery_amount_text
      margin-left: 8px
      font-size: 12px
      // list-style: 46px
      color: rgba(0, 0, 0, .75)

  .top
    .order_title
      padding-left: 16px
      color: var(--menu-primary-text-colour)

    .member
      margin-top: 10px

      .member_title
        font-size: 14px
        line-height: 14px
        font-weight: 500
        color: var(--menu-primary-background-colour)

      .member_input
        display: flex
        border: 1px solid rgba(50, 56, 62, .2)
        margin-top: 4px
        border-radius: 4px

        ::v-deep
          .van-cell
            padding: 6px 0 6px 12px
            color: #334455
            border-radius: 4px

      .member_verify
        display: flex
        align-items: center
        margin-top: 6px
        padding: 0 12px
        font-size: 14px
        font-weight: 500
        border-radius: 4px !important
        color: $textWhiteColor !important
        background: var(--menu-primary-background-colour) !important

      .prompt_text
        display: flex
        align-items: center
        margin-top: 10px
        font-size: 12px

        .icon
          margin-right: 6px
          font-size: 14px

      .success_text
        color: #17A341

      .error_text
        color: #B00620

  .content
    display: flex
    flex-direction: column
    padding-top: 25px

    .order_details
      margin-bottom: 12px
      padding: 14px
      color: #334455
      background: rgba(50, 56, 62, .05)
      border-top: 1px solid rgba(51, 68, 85, .1)
      border-bottom: 1px solid rgba(51, 68, 85, .1)

      &.delivery_order_details
        .order_details_item
          .order_details_item_title
            min-width: 60px

      .order_details_header
        display: flex
        font-size: 16px
        font-weight: bold

        .order_details_header_edit
          margin-left: 4px
          color: var(--menu-primary-background-colour)
          cursor: pointer

      .order_details_item
        display: flex
        font-size: 12px

        .order_details_item_title
          margin-right: 4px
          min-width: 70px
          font-weight: bold

    .type
      display: flex
      justify-content: space-between
      align-items: center
      margin-bottom: 25px
      padding: 0 16px

      .dine_in
        flex: 1
        height: 38px
        line-height: 38px
        margin-right: 20px
        border: 1px solid var(--menu-primary-background-colour)
        border-radius: 3px !important
        color: var(--menu-primary-background-colour)

      .take_out
        flex: 1
        height: 38px
        line-height: 38px
        border: 1px solid var(--menu-primary-background-colour)
        border-radius: 3px !important
        color: var(--menu-primary-background-colour)

  .add_note
    height: 56px
    width: 100%
    margin-bottom: 10px
    padding-left: 16px
    font-size: 14px
    line-height: 56px
    background: $backGroundColor
    color: var(--menu-primary-text-colour)

    .font_italic
      font-style: italic

    .color_red
      color: red

  .order_title
    font-size: 16px
    color: $noteColor
    font-weight: 500

  .footer
    height: 56px

.total_price
  font-size: 15px
  color: var(--menu-primary-text-colour)
  text-align: center

  .money
    font-weight: 500

.form
  padding: 0 16px
  margin-bottom: 10px

.comment
  padding: 0 16px
  padding-bottom: 40px

.area
  padding: 0 16px
  margin-top: 15px
  margin-bottom: 40px

.allergy_content
  width: 242px

  .allergy_text
    margin: 26px 0 21px 0
    text-align: center
    font-size: 15px
    color: #334455

  .allergy_img
    display: flex
    justify-content: center

    .img
      width: 57px

  .allergy_btn
    height: 56px
    font-size: 15px

::v-deep
  .van-stepper--round .van-stepper__plus
    background-color: var(--menu-primary-background-colour) !important

  .van-stepper--round .van-stepper__minus
    border-color: var(--menu-primary-background-colour) !important
    background-color: var(--menu-primary-background-colour) !important

  .van-button--primary
    background-color: var(--menu-primary-background-colour)

  .disabled
    background-color: #ddd !important

.tableId_select
  position: relative

::v-deep
  #textArea
    color: var(--menu-primary-text-colour) !important

  .select.disabled
    background-color: unset !important

  .select
    position: absolute
    top: 23PX
    right: 0
    width: 150PX

    .mu-select
      justify-content: flex-end

    .mu-select-content,
    .mu-input-line,
    .mu-input-focus-line
      display: none

    .mu-select-icon
      width: 24PX
      height: 24PX
      color: #D4D4D4

.sub_total
  display: flex
  flex-direction: column
  padding: 5px 16px
  border-bottom: 1px solid #f1f2f3

  .item
    display: flex
    justify-content: space-between
    align-items: center
    font-size: 12px
    line-height: 22px
    color: var(--menu-primary-text-colour) !important

.currency_warning
  display: flex
  align-items: flex-start
  margin: 10px 14px
  padding: 10px 12px
  background: #FFF8E6
  border: 1px solid #FFD666
  border-radius: 6px

  .warning_icon
    flex-shrink: 0
    width: 20px
    height: 20px
    margin-right: 8px
    background: #FFB800
    border-radius: 3px
    display: flex
    align-items: center
    justify-content: center
    color: #fff
    font-weight: bold
    font-size: 12px

  .warning_content
    flex: 1

    .warning_title
      font-size: 12px
      font-weight: 600
      color: #333
      margin-bottom: 2px

    .warning_text
      font-size: 11px
      color: #666
      line-height: 1.4

.order_recommend
  width: 100%
  height: 132PX
  background: #32383E0D 0% 0% no-repeat padding-box
  opacity: 1

  .title
    text-align: left
    font-size: 12px
    //line-height: 22px
    letter-spacing: 0PX
    color: #000000
    opacity: 0.75
    padding: 5px 16px

  .product_list
    display: flex
    flex-wrap: nowrap
    overflow-x: scroll
    scrollbar-width: none
    margin-bottom: 10PX
    margin-left: 10PX

::v-deep
  .allergy
    max-height: calc(95vh - 70PX)

    .app_container
      padding: 31px 26px 26px 27px

.venue_cart_section
  .venue_title
    height: 34PX
    background: #32383E0D 0% 0% no-repeat padding-box
    display: flex
    justify-content: space-between
    align-items: center

    .name
      font-size: 15px
      font-weight: bold
      margin-left: 16PX

  ::v-deep
    .order_items
      .first
        .num
          font-size: 14PX
      .left
        .title
          font-size: 14PX
      .left_combo
        .title
          font-size: 14PX
    .await_container
      margin-top: 0PX
      font-size: 12PX
      margin-right: 20PX

</style>

<style lang="sass">
body
  .full_width_select
    width: 100% !important

  .tableId_mu_popover.mu-popover
    left: 16px
    width: calc(100vw - 32px)
    max-width: none

    .mu-option.is-selected .mu-item
      color: var(--menu-primary-background-colour)
</style>

<template lang="pug">
  .app_container
    #scroll_bar.content.overflow_scroll
      // @TODO need to remove twob bird sp settings in future | glasshouse
      //py-form.form(
      //  v-if='number || $store.state.venueId === "b81621f1-5c82-4b97-98dd-93d7b9cdd106" || $store.state.venueId === "fdcc96f2-c145-4dc4-9c6e-8027b4b9c55b" || ($store.state.venueId === "4380f789-c561-4dc7-a510-6f9a48fbb3b9" && !isOnline) || ($store.state.forceTableInput && !isOnline)',
      //  ref='form',
      //  :model='valueFields',
      //  :rules='ruleValidate'
      //)
      //  py-form-item(prop='tableId')
      //    py-input(
      //      v-if='!tableList.length',
      //      :title='title',
      //      v-model='valueFields.tableId',
      //      @input='anewGetTableExtra'
      //    )
      //    .tableId_select(v-else)
      //      py-input(
      //        :title='title',
      //        :disabled="true",
      //        v-model='valueFields.tableId',
      //        @input='anewGetTableExtra'
      //      )
      //      mu-select.select(
      //        v-model='valueFields.tableId',
      //        tags,
      //        :disabled="disableTableSelect"
      //        popover-class='tableId_mu_popover'
      //        @change='anewGetTableExtra'
      //        class="full_width_select"
      //      )
      //        mu-option(
      //          v-for='(item, index) in tableList',
      //          :key='index',
      //          :label='item.name',
      //          :value='item.name'
      //        )

      // glasshouse wont display dine-in/takeaway otpion
      //.type(
      //  v-if='showOrderType && !number && takeaway === "takeaway" && !isOnline && !$store.state.forceTableInput && $store.state.venueId !== "4380f789-c561-4dc7-a510-6f9a48fbb3b9"'
      //)
      //  van-button.dine_in(
      //    :class='{ touched: inTouched }',
      //    @click='inTouchedFun'
      //  )
      //    icon.icon restaurant
      //    span.text Dine-in
      //  van-button.take_out(
      //    :class='{ touched: outTouched }',
      //    @click='outTouchedFun'
      //  )
      //    icon.icon local_mall
      //    span.text Takeaway
      .venue_cart_section(
        v-for="(venueCart, venueIdIndex) in subgroupCart"
      )
        template(v-if="venueCart.cart && venueCart.cart.length > 0")
          .venue_title
            .name {{ subgroupVenueList[venueIdIndex].name }}
            await-time(v-if='showAwaitTime(subgroupVenueList[venueIdIndex])' :full="false" :await-time='getWaitTime(subgroupVenueList[venueIdIndex]) || 15')
          .items
            order-items.order_item(
              v-for='(item, index) in venueCart.cart',
              :key='item.id + index',
              :data='item',
              :index='index'
              :selectVID="venueIdIndex"
              :isSubGroupMode="true"
            )
      .top
        //.order_title Items:
        //order-items.order_item(
        //  v-for='(item, index) in proList',
        //  :key='item.id + index',
        //  :data='item',
        //  :index='index'
        //)
        .order_recommend(v-if='recommendProductList.length > 0')
          .title {{ t('add_something_extra', 'Add something extra:') }}
          .product_list
            recommend-item.p(
              v-for="item in (recommendProductList)"
              :key="item.id"
              :name="item.name"
              :description="item.description"
              :descriptionIsHtml="item.settings && item.settings.useHtmlDescription"
              :price="item.price"
              :tags="item.tags"
              :enablePopular="item.enablePopular"
              :quantity="item.num"
              :maskDisplay="!item.status"
              :imgUrl="item.image"
              :size-settings="item.sizeSettings"
              :hide-price="item.hidePriceInDesc ? item.hidePriceInDesc : false"
              :unavailableText="t('sold_out', 'Sold Out')"
              @add="addProductToCart(item)"
            )

        .sub_total
          .item.o
            div {{ t('subtotal', 'Subtotal:') }}
            div {{ symbolPosition === 'after' ? '' : currencySymbol }}{{ cvt(total) | fix }}{{ symbolPosition === 'after' ? ' ' + currencySymbol : '' }}
          .item.o(v-if='hasPaymentHolidaySurcharge')
            div {{surchargeHead}}:
            div {{ symbolPosition === 'after' ? '' : currencySymbol }}{{ cvt(publicHolidaySurcharge) | fix }}{{ symbolPosition === 'after' ? ' ' + currencySymbol : '' }}

          .item.o(v-if='isOnline && deliveryInfo.orderType === "delivery"')
            div {{ t('delivery_fee', 'Delivery fee:') }}
            div {{ symbolPosition === 'after' ? '' : currencySymbol }}{{ cvt(baseFee) | fix }}{{ symbolPosition === 'after' ? ' ' + currencySymbol : '' }}
          .item.o(v-if='merchantFeePrice !== 0')
            div {{ t('payment_surcharge', 'Venue Surcharge') }}:
            div {{ symbolPosition === 'after' ? '' : currencySymbol }}{{ cvt(merchantFeePrice) | fix }}{{ symbolPosition === 'after' ? ' ' + currencySymbol : '' }}
          .item.b
            div {{ t('total_amount_paid', 'Total amount paid:') }}
            div {{ symbolPosition === 'after' ? '' : currencySymbol }}{{ cvt(totalAll) | fix }}{{ symbolPosition === 'after' ? ' ' + currencySymbol : '' }}
        //- Currency estimate warning banner / 货币估算警告横幅
        .currency_warning(v-if="showCurrencyWarning")
          .warning_icon !
          .warning_content
            .warning_title {{ currencyWarningTitle }}
            .warning_text {{ currencyWarningText }}
        .add_note(v-show="!disableComment") {{ t('add_a_note', 'Add a note') }}
          span.color_red &nbsp;(
          span.font_italic.color_red {{ t('no_emojis_please', 'no emojis please') }}
          span.color_red )
          span :
      py-text-area#textArea.area(
        v-show="!disableComment"
        v-model='comment',
        v-bind:style='{ height: height + "px" }',
        :label='notePlaceholder',
        :height='height'
      )
    //- 多版本菜单 B6（U-B6-3，owner D56 / D98①）：菜单预览页不能下单 —— 结账按钮变灰，旁边说为什么
    .preview_order_reason(v-if='previewOrderBlocked' role='status') {{ previewOrderReason }}
    footer-bar.footer_bar_absolute(
      :status='status',
      :disabled='!hasProduct || !isVenueGroupOpenTime || hasExpireProduct || previewOrderBlocked',
      @clickButton='checkOrderProcess'
    )
      template(v-slot:left)
        .total_price
          span {{ t('order_total', 'Order total:') }}
          span.money.ls1 {{ symbolPosition === 'after' ? ' ' : ' ' + currencySymbol }}{{ cvt(totalAll) | fix }}{{ symbolPosition === 'after' ? ' ' + currencySymbol : '' }}
    bottom-popup-dialog.allergy(
      v-model="showAllergyDialog"
      position="center"
      :showCloseIcon="false"
      @changeShow="closeAllergyDialog"
    )
      template(v-slot:popup-dialog)
        .allergy_content
          .allergy_img
            img.img(:src="warningIcon")
          .allergy_text {{ allergyText }}
          van-button.allergy_btn.b.ls1(type="primary" block @click="closeAllergyDialog") {{ t('ok', 'OK') }}
</template>

<script>
import Component, { mixins } from 'vue-class-component'
import mixin from '@/utils/mixin'
import { _numberUpFixed } from '@/utils/number'
import { getCurrencySymbol, getSymbolPosition, convertPrice, needsConversion, hasMultipleCurrencies, getCurrentCurrencyInfo, getDefaultCurrency } from '@/utils/currency'
import { t, tParams } from '@/utils/language'
import { safeDecodeURI } from 'utils'
import { surchargeName } from '@/utils/surcharge'
import { startSurchargeAutoRefresh, ensureSubGroupSurchargeSources, refreshSubGroupSurcharges, subGroupCartInfoFor } from '@/utils/surchargeSnapshot'
import { getVenueQuietly } from '@/api/venueQuiet'
import OrderItems from '@/views/cart/component/Items'
import AwaitTime from '@/views/cart/component/AwaitTime'
import RecommendItem from '@/views/cart/component/RecommendItem'
import {
  getUserOrders,
  payOrder,
  getVenueGroup,
  getTableExtra,
  otherAction
} from '@/api/product'
import { updateTab } from 'api/tab'
import { mapGetters, mapState } from 'vuex'
import { vuexStoreLoading } from 'utils/decorators'
import dayjs from 'dayjs'
import { isIOS } from '@/utils/navigator'
import {
  MessageDialog
} from '@/plugins/createApi'
import resizeHandler from 'utils/resizeHandler'
import * as MessageDict from 'utils/message'
import { _hexToRgb } from '../../../utils/format'
import { trackFunnelEvent } from 'utils/funnelTracking'
import { NO_INPUT_TABLE_NUMBER } from 'utils/constants'
import { isOrderingBlockedByPreview, stopOrderingForPreview } from '@/utils/menu/previewOrderBlock'
import { previewOrdersDisabledText } from '@/utils/menu/previewMenuCopy'
import { keepMenuMarks, markAppliesInSubGroup } from '@/utils/menu/cartMarks'

@Component({
  mixins: [resizeHandler],

  watch: {
    comment() {
      this.getHight()
    },

    // Are there any expired products in the shopping cart
    // 购物车有没有过期商品（多版本菜单 B6 review 第 3 轮 H3：合单这里不看「不在当前菜单上」的标记，清空时也不清它 —— 那是单店那次留下的，回单店购物车还要用）
    hasExpireProduct(val) {
      if (!val) this.$store.commit('saveExpireProductList', keepMenuMarks(this.expireProductList))
    },

    // Listen to url query
    // 监听 url query
    $route: {
      handler(val) {
        // if (val.query.openDeliveryInfo && this.isOnline) this.showOrderTypeDialog()
      },
      immediate: true,
    },

    // If there is no number, clear the table in vuex
    // 若没有 number, 则把 vuex 中的 table 清空
    number: {
      handler(val) {
        if (!val) this.saveTable('')
      },
      immediate: true,
    },
    publicHolidaySurcharge: {
      handler(val) {
        // Save the latest service charge amount in app - details in vuex
        // vuex 中 app - details 数据，保存最新的服务费金额
        // this.$store.commit('addDetailsProp', {
        //   prop: 'surchargeAmount',
        //   val: parseFloat(val ?? 0),
        // })
      },
      immediate: true,
    },
  },

  beforeDestroy() {
    if (this._stopSurchargeAutoRefresh) this._stopSurchargeAutoRefresh()
  },

  async mounted() {
    // 页面开着期间每 30 秒 / 切回前台时重判附加费：当前在逛的店 + 每家成员店按自己的配置（review 第 1 轮 #4 / #5）
    this._stopSurchargeAutoRefresh = startSurchargeAutoRefresh(this.$store, { subGroup: true })
    // 缺判定依据的成员店（上线前加购的）补拉门店设置后重判一次，页面上的合计与结账时一致（Codex 第 2 轮 #3）
    this._ensureMemberSurcharges()
    if (this.$route.query.fromPortal === 'true') {
      document.body.style.setProperty('--menu-primary-background-colour', '#000000')
      document.body.style.setProperty('--menu-header-background-colour', '#000000')
      document.body.style.setProperty('--menu-primary-background-colour-rgb', _hexToRgb('#000000'))
    }
    // If query - portal === 'true', hide the option of selecting order type
    // 若 query - portal === 'true'，则隐藏选择订单类型选项
    if (this.$route.query.portal === 'true') this.showOrderType = false
    await this.__checkVenueSubgroupOpenTime()
    this.$store.commit('showLoading')
    await this._filterAndSaveUnfinishOrder()
    this._getNumber()
    if (this.takeaway === 'takeaway') {
      this.outTouched = false
      this.inTouched = true
    }
    const orderType = localStorage.getItem('orderType')
    if (orderType) {
      this.outTouched = true
      this.inTouched = false
    }
    this.addListen()
    // if (this.$route.query.openDeliveryInfo) this.showOrderTypeDialog()
    if (this.venueIsGuests) this._getTableExtra()
    await this._getCartRecommend() // get recommend list
    await this._getVenueSubGroup()
    this.cleanCart()

    // If the routing query contains ta, the order type is set to takeaway
    // 若路由 query 中带有 'ta'，则订单类型设置为 takeaway
    if ('ta' in this.$route.query && !(this.venueSubGroupSettings?.dineInSettings?.enableTakeaway === false)) {
      localStorage.setItem('orderType', 'takeaway')
      this.$store.commit('addDetailsProp', {
        prop: 'orderType',
        val: 'takeaway'
      })
    }

    // await this._setDeliveryCost()
    this.$store.commit('closeLoading')
    if (this.$openreplayTracker) this.$openreplayTracker.event('view_cart')
    if (this.$gtag) {
      this.$gtag.event('view_cart', {
        event_category: 'purchase_journey',
        event_label: 'View Cart',
      })
    }
  },

  props: {
    number: [String, Number],
    venueSubGroupId: {
      type: String,
      default: null
    }
  },

  filters: {
    fix(val) {
      return _numberUpFixed(val)
    },
  },

  components: {
    OrderItems,
    AwaitTime,
    // DeliveryInfoDialog,
    RecommendItem
  },

  computed: {
    // 多版本菜单 B6（U-B6-3，owner D98①）：合单页地址带菜单预览码 ⇒ 本地拦单（依赖 $route，跳转后重算）
    previewOrderBlocked() {
      return isOrderingBlockedByPreview(this.$route)
    },

    previewOrderReason() {
      const _lang = this.$lang // eslint-disable-line no-unused-vars
      return previewOrdersDisabledText()
    },

    // Table number/zone title - reactive to language changes
    // 桌号/区域标题 - 响应语言变化
    tableNumberZoneTitle() {
      const _lang = this.currentLanguage // eslint-disable-line no-unused-vars
      return t('table_number_zone', 'Table number/zone')
    },

    // Add note placeholder - reactive to language changes
    // 添加备注占位符 - 响应语言变化
    notePlaceholder() {
      const _lang = this.currentLanguage // eslint-disable-line no-unused-vars
      return t('add_note_here', 'Add note here')
    },

    ...mapState({
      currentLanguage: state => state.language?.currentLanguage,
      currentCurrency: state => state.currencySettings?.currentCurrency,
      expireProductList: (state) => state.expireProductList,
      subgroupCart: (state) => state.venueHome.subGroupCartList,
      subgroupVenueList: (state) => state.venueHome.subGroupVenueList,
      // spDiscounts: (state) => state.spDiscounts,
      // spDiscountsCode: (state) => state.spDiscountsCode,
      // isOnline: (state) => state.app.isOnline,
      // paymentSurcharge: (state) => state.app.paymentSurcharge,
      // paymentSurchargeSettings: (state) => state.app.paymentSurchargeSettings,
      // onlineDisabledButton: (state) => state.app.onlineDisabledButton,
      // vuexDeliveryInfo: (state) =>
      //     state.contactDetails?.deliveryInfo[state.venueId] ?? {},
      userInfo: (state) => state.contactDetails.user,
      // venueAddress: (state) =>
      //   state.venueHome.pickupSettings &&
      //     state.venueHome.pickupSettings.pickupAddress &&
      //     state.venueHome.pickupSettings.pickupAddress !== ''
      //     ? state.venueHome.pickupSettings.pickupAddress
      //     : state.venueHome.address,
      // venueIsGuests: (state) => state.venueHome.isGuests,
      // deliverySetting: (state) => state.venueHome.deliverySetting,
      // discountRules: (state) => state.venueHome.discountRules,
      routerInfo: (state) => state.venueHome.routerInfo,
      venueGroupSettings: (state) => state.venueHome.venueGroupSettings
    }),

    hasPaymentHolidaySurcharge() {
      return this.$store.getters.subGroupCartHasHolidaySurcharge()
    },

    disableComment() {
      // return this.venueGroupSettings?.disableGroupComment ?? false
      return false
    },

    disableTableSelect() {
      return this.venueGroupSettings?.disableTableSelect ?? false
    },

    isNoTable() {
      return this.routerInfo?.noTable ?? false
    },

    buttonColor() {
      return this.$store.state.app.color.menu_primary_background_colour
    },

    // 多版本菜单 B6（U-B6-2 review 第 2 轮 G3）：与单店购物车同一条 —— 本功能写的标记不算在店家强塞的行上，老标记照今天按 id。
    // review 第 3 轮 H3：「不在当前菜单上」（source: menu）的标记不算 —— 合单一律主菜单、从不做 D97（D98①），那是单店那次留下的
    hasExpireProduct() {
      return !!this.expireProductList.find((expire) =>
        this.proList.find((item) => markAppliesInSubGroup(expire, item)),
      )
    },

    merchantFeePrice() {
      return this.$store.getters.subGroupCartMerchantFeePrice()
    },

    totalAll() {
      return this.$store.getters.subGroupCartRealPrice()
    },

    merchantFee() {
      return this.$store.state.app.merchantFee
    },

    hasProduct() {
      return this.$store.getters.subGroupCartHasProduct()
    },

    /**
     * @returns {Number} Public holiday surcharge amount
     */
    /**
     * @returns {Number} 公共假日附加费的金额
     */
    publicHolidaySurcharge() {
      // 各家成员店附加费之和（每家用自己的费率、各自取整），与合计同源；以前只算当前这一家
      return this.$store.getters.subGroupCartPublicHolidaySurchargeTotal()
    },

    // Mirror of cart/index.vue surchargeHead — route through the shared surchargeName helper.
    // Locale-safe weekday key (no format('dddd')); date reads the nested settings.group.
    // (paymentSurcharge/paymentSurchargeSettings mapState stays commented per D5 multi-venue
    // surcharge being out of scope, so this falls to the localized today-weekday fallback.)
    surchargeHead() {
      const _lang = this.currentLanguage // eslint-disable-line no-unused-vars
      const WEEKDAYS = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday']
      const s = this.paymentSurchargeSettings
      if (this.paymentSurcharge > 0 && s !== '' && s && s.type === 'date') {
        return surchargeName({ type: 'date', group: s.settings && s.settings.group, settings: s })
      }
      if (this.paymentSurcharge > 0 && s !== '' && s && s.type === 'weekly') {
        return surchargeName({ type: 'weekly', weekDay: WEEKDAYS[dayjs.tz().day()], settings: s })
      }
      // No settings / legacy: fall back to today's weekday surcharge
      return surchargeName({ type: 'weekly', weekDay: WEEKDAYS[dayjs.tz().day()] })
    },

    total() {
      return this.$store.getters.subGroupCartTotal()
    },

    proList() {
      return this.$store.state.productList.filter(
        (item) => item.venueId === this.venueId,
      )
    },

    table() {
      return this.$store.state.table
    },

    takeaway() {
      // The takeaway here is not a real takeaway passed to the interface, but an identifier to determine whether takeaway is allowed. The real change depends on the takeaway in the locaStorage
      // 这里的 takeaway 不是真实的传给接口的 takeaway，而是一种标识符，来判断是否允许 takeaway，真正的改变根据 locaStorage 中的 takeaway 决定
      return this.$store.state.details.orderType
    },

    venueId() {
      return this.$store.state.venueId
    },

    padding() {
      return this.$store.state.app.request
    },

    isPostPaid() {
      return this.$store.state.venueHome.routerInfo.paymentType === 'post-paid'
    },

    userId() {
      return localStorage.getItem('userId')
    },

    isPrePaidOrder() {
      return this.$store.state.venueHome.routerInfo.paymentType === 'pre-paid'
    },

    isVenueGroupOpenTime() {
      return true
    },
    currencySymbol() {
      const _c = this.$currencyCode // eslint-disable-line no-unused-vars
      return getCurrencySymbol()
    },
    symbolPosition() {
      const _c = this.$currencyCode // eslint-disable-line no-unused-vars
      return getSymbolPosition()
    },

    // Whether to show currency estimate warning / 是否显示货币估算警告
    showCurrencyWarning() {
      const _c = this.$currencyCode // eslint-disable-line no-unused-vars
      return hasMultipleCurrencies() && needsConversion()
    },

    // Currency warning title text / 货币警告标题文本
    currencyWarningTitle() {
      const _c = this.$currencyCode // eslint-disable-line no-unused-vars
      const _lang = this.$lang // eslint-disable-line no-unused-vars
      const currencyInfo = getCurrentCurrencyInfo()
      const currencyName = currencyInfo.name || currencyInfo.code
      return tParams('currency_estimate_warning', 'Prices shown in {currency} are an estimate only.', {
        currency: currencyName,
      })
    },

    // Currency warning detail text / 货币警告详情文本
    currencyWarningText() {
      const _c = this.$currencyCode // eslint-disable-line no-unused-vars
      const _lang = this.$lang // eslint-disable-line no-unused-vars
      const defaultCurrency = getDefaultCurrency()
      return tParams(
        'currency_charge_notice',
        'You\'ll be charged in {defaultCurrency}. Your bank may apply a different exchange rate and fees.',
        { defaultCurrency }
      )
    },
  },
})

class SubGroupCart extends mixins(mixin) {
  warningIcon = require('@/assets/tab-pics/warning-icon.png')
  showOrderType = true
  // Allergy prompt box switch
  // 过敏提示框的开关
  showAllergyDialog = false
  ls = []
  recommendProductList = []

  height = '46'
  // Form authentication
  // 表单验证
  valueFields = {
    tableId: '',
  }

  ruleValidate = {
    tableId: [
      {
        required: true,
        message: t('select_table_number', 'Please select your table number/zone'),
        trigger: 'blur',
      },
      {
        validator: this._tableNumValidate,
        trigger: 'blur'
      },
    ],
  }

  isIOS = isIOS()
  status = 3
  inTouched = false
  outTouched = false
  comment = ''
  routerName = ''

  timer = null
  deliveryInfo = {}
  venueSubGroupSettings = null
  venueList = []
  tableList = [] // Table number list   // 桌号列表
  // Anaphylaxis prompt
  // 过敏提示语
  allergyText = ''

  t(key, fallback) {
    const _lang = this.$lang // eslint-disable-line no-unused-vars
    return t(key, fallback)
  }

  /**
   * Convert price to display currency / 转换价格到显示货币
   * References this.currentCurrency for Vue reactivity / 引用 this.currentCurrency 以实现 Vue 响应式
   */
  cvt(price) {
    // eslint-disable-next-line no-unused-vars
    const _currency = this.currentCurrency
    return convertPrice(price)
  }

  // Close the allergy prompt box
  // 关闭过敏提示框
  closeAllergyDialog() {
    this.showAllergyDialog = false
    this.$store.commit('saveAlcoholButton', true)
  }

  checkOrderProcess() {
    // 多版本菜单 B6（U-B6-3）：菜单预览页不能下单（按钮已变灰；这里兜住按钮状态还没更新的那一下）
    if (stopOrderingForPreview(this.$route)) return
    this.__checkVenueSubgroupTodayIsOpenTime(this.validateAndSaveInfo)
  }

  validateAndSaveInfo() {
    // Save comment first
    // 先保存 comment
    this.saveComment(this.comment)
    // These two steps are priority
    // 这两步是优先的
    this._checkIncludeAlcohol()
    if (
      this.number || this.$store.state.forceTableInput
    ) {
      // The table-number form in the template is commented out (@TODO twob bird sp settings),
      // so $refs.form may not exist. Save the table derived from the route
      // (empty for the 'n-t' placeholder) and place the order directly.
      // 模板中的桌号表单已被注释掉(@TODO twob bird sp settings),$refs.form 可能不存在。
      // 直接保存路由解析出的桌号('n-t' 占位符时为空)并继续下单。
      if (!this.$refs.form) {
        // Re-derive from the current route: mounted may not have run _getNumber yet,
        // and the watcher doesn't refresh tableId when navigating between tables.
        // 从当前路由重新解析:mounted 可能还没执行到 _getNumber,
        // 且切换桌号路由时 watcher 不会刷新 tableId。
        this._getNumber()
        // The table comes from a user-editable URL segment — cap the length
        // before it reaches the order payload / receipt printers.
        // 桌号来自用户可改的 URL 路径段,先截断长度再进订单/小票。
        this.saveTable(this.valueFields.tableId.slice(0, 64))
        this._coreHandlePlaceOrderButton()
        return
      }
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$store.commit('showLoading')
          this.saveTable(this.valueFields.tableId)
          this._coreHandlePlaceOrderButton()
        } else {
          this.$store.commit('closeLoading')
          // scroll to top
          window.scrollTo({
            top: 0,
            left: 100,
            behavior: 'smooth',
          })
        }
      })
    } else {
      this._coreHandlePlaceOrderButton()
    }
  }

  _checkIncludeAlcohol() {
    const target = 'Alcohol'

    // First judge whether the product contains alcohol
    // 先判断商品中是否含有酒精
    let hasAlcohol = false
    for (var i in this.subgroupCart) {
      if (this.subgroupCart[i].cart && this.subgroupCart[i].cart.length > 0) {
        const proList = this.subgroupCart[i].cart
        let iHasAlcohol = !!this._.find(proList, (pro) =>
          pro.containsTags.find((tag) => tag === target),
        )
        const comboList = proList.filter((pro) => pro.type === 'combo')
        // If the product does not contain alcohol and there is combo. Then check whether there is alcohol in the single product of combo
        // 若商品中没有含有酒精，并且存在 combo。则去 combo 的单品里，查看是否有含酒精
        if (!iHasAlcohol && comboList.length) {
          // The field without containsTags is treated as an empty array
          // 没有 containsTags 这个字段时，按照空数组处理
          iHasAlcohol = !!this._.find(comboList, (combo) =>
            this._.find(combo.comboProducts, (product) =>
              this._.find(product.itemList, (item) =>
                (item?.containsTags ?? []).find((tag) => tag === target),
              ),
            ),
          )
        }
        hasAlcohol = hasAlcohol || iHasAlcohol
      }
    }
    this.$store.commit('checkIncludeAlcohol', Boolean(hasAlcohol))
  }

  // Get table related information
  // 获取 table 相关信息
  async _getTableExtra() {
    this.$store.commit('showLoading')
    const res = await getTableExtra({
      venueId: this.venueId,
      tableNo: this.valueFields.tableId ? this.valueFields.tableId : '',
    }).catch((error) => {
      console.log(error)
      this.$store.commit('closeLoading')
    })
    this.tableExtra = res
    this.$store.commit('closeLoading')
  }

  _getUnPaidOrderInfo() {
    let unPaidOrderId
    let unPaidOrderNo
    const index = this.$store.state.venueUnpaidOrderList.findIndex(
      (item) => item.venueId === this.venueId,
    )
    if (index !== -1) {
      unPaidOrderId =
          this.$store.state.venueUnpaidOrderList[index].unPaidOrderId
      unPaidOrderNo =
          this.$store.state.venueUnpaidOrderList[index].unPaidOrderNo
    }
    return [unPaidOrderId, unPaidOrderNo]
  }

  /**
   * 检查环境数据
   * @returns {Boolean} 是否检查成功
   */
  _checkEnvironmentalData() {
    // 是否通过检查
    let isPass = true
    const { orderType } = this.$store.state.details
    const isTakeaway = this.$route.path.includes('/v/o/') || this.$route.path.includes('/online/')
    // table 环境
    if (this.$route.name === 'cart-table' || this.$route.name === 'venue-home-table') {
      const num = this.number || ''
      // 若不存在 tbale 数据，弹窗提示
      if (!(safeDecodeURI(num) || this.table)) {
        isPass = false
      }
    } else if (isTakeaway && this.$route.query.portal === 'true' && (this.$route.query.ta === null || this.$route.query.ta === undefined)) { // takeaway 环境
      if (orderType !== 'takeaway') {
        isPass = false
      }
    } else if (this.$route.query.portal === 'true') { // counter 环境
      if (orderType !== 'dine-in') {
        isPass = false
      }
    }
    // 检查不通过的时候，弹窗提醒
    if (!isPass) {
      MessageDialog.$create({
        content: t('session_expired', 'Your session has expired. Please scan the QR code to start your new order.')
      }).show()
    }
    return isPass
  }

  // 接收 3 个数组，去掉 arr 中包含 brr 和 crr 的对象
  deleteDuplicate(arr, brr, crr) {
    const c = []
    const y = []
    arr.forEach((item) => {
      const check = brr.every(function (b) {
        return item.name !== b.name
      })
      if (check) {
        c.push(item)
      }
    })
    c.forEach((item) => {
      const check = crr.every(function (b) {
        return item.name !== b.name
      })
      if (check) {
        y.push(item)
      }
    })
    return y
  }

  async _filterAndSaveUnfinishOrder() {
    // filter and save unOverOrders
    if (this.userId) {
      await this._updateUnfinishOrders()
    } else {
      this.$store.commit('clearUnpaidOrder', this.venueId)
    }
  }

  async _updateUnfinishOrders() {
    const orders = await this._getUserUnOverOrders('nostart_all')
    const ordersTotal = parseInt(orders.total)
    if (ordersTotal > 0) {
      const filtersOrder = orders.orders.filter((item) => {
        if (item.paymentStatus === 0 && item.status <= 40) {
          return item
        }
      })
      if (filtersOrder.length > 0) {
        const order = filtersOrder[0]
        this._updateVenueUnpaidOrderList(order.id, order.orderNo)
      } else {
        this.$store.commit('clearUnpaidOrder', this.venueId)
      }
    } else {
      this.$store.commit('clearUnpaidOrder', this.venueId)
    }
  }

  _updateVenueUnpaidOrderList(orderId, orderNo) {
    this.$store.commit('saveVenueUnpaidOrderList', {
      venueId: this.venueId,
      unPaidOrderId: orderId,
      unPaidOrderNo: orderNo,
    })
  }

  async _getUserUnOverOrders(type) {
    const res = await getUserOrders({
      venueId: this.venueId,
      id: this.userId,
      type: type,
      pageSize: 5,
      pageNo: 1,
    }).catch((error) => {
      console.log(error)
      this.$store.commit('closeLoading')
    })
    return res
  }

  addListen() {
    if (!this.isIOS) {
      const dom =
          document.getElementById('textArea').children[0] ||
          document.getElementById('textArea')
      dom.addEventListener('focus', function () {
        // Top: 3000 means infinity
        // top: 3000 的意思是无穷大
        window.scrollTo({
          top: 3000,
          left: 100,
          behavior: 'smooth',
        })
      })
    }
  }

  getHight() {
    if (!this.isIOS && this.isMobile) {
      window.scrollTo({
        top: 3000,
        left: 100,
        behavior: 'smooth',
      })
    }
    const textArea =
        document.getElementById('textArea').children[0].scrollHeight
    console.log(this.ls[this.ls.length - 2])
    if (this.ls.includes(textArea)) {
    } else {
      const max = Math.max(...this.ls)
      if (textArea > max) {
        this.ls.push(textArea)
        if (textArea <= 40) {
          this.height = 40
        } else {
          this.height = textArea
        }
      } else {
        console.log('small')
        this.ls.splice(this.ls.length - 1, 1)
        this.height = this.ls[this.ls.length - 1] || 40
      }
    }
  }

  _validate(value) {
    return !!value
  }

  _tableNumValidate(rule, value, callback) {
    const res = this._validate(value)
    if (!res) {
      callback(new Error(t('input_table_number', 'Please input table number/name')))
    } else {
      callback()
    }
  }

  _getNumber() {
    const num = this.number || ''
    if (num === NO_INPUT_TABLE_NUMBER || num === '') {
      this.valueFields.tableId = ''
    } else {
      this.valueFields.tableId = safeDecodeURI(num) || this.table
    }
  }

  async _coreHandlePlaceOrderButton() {
    this.$store.commit('showLoading')

    this.jumpToContactDetail()
    this.$store.commit('closeLoading')
  }

  jumpToContactDetail() {
    const isPass = this._checkEnvironmentalData()
    if (!isPass) return

    if (this.$openreplayTracker) this.$openreplayTracker.event('begin_checkout')
    trackFunnelEvent('begin_checkout')
    if (this.$gtag) {
      this.$gtag.event('begin_checkout', {
        event_category: 'purchase_journey',
        event_label: 'Checkout - Contact Detail',
      })
    }
    this.$router.push(`/vgs/${this.venueSubGroupId}/contact-details?fromSubgroup=true`)
  }

  saveTable(val) {
    this.$store.commit('addDetailsProp', {
      prop: 'table',
      val,
    })
    this.$store.commit('saveRouterInfo', {
      prop: 'number',
      val: val
    })
  }

  saveComment(val) {
    this.$store.commit('addDetailsProp', {
      prop: 'comment',
      val,
    })
  }

  inTouchedFun() {
    this.outTouched = false
    this.inTouched = true
    localStorage.setItem('orderType', '')
  }

  outTouchedFun() {
    this.outTouched = true
    this.inTouched = false
    localStorage.setItem('orderType', 'takeaway')
  }

  async _getVenueSubGroup() {
    const subGroupInfo = await getVenueGroup({
      id: this.venueSubGroupId,
      type: 'subGroup',
    }).catch(error => {
      console.log(error)
      this.$store.commit('closeLoading')
    })
    this.$store.commit('closeLoading')

    this.venueSubGroupSettings = subGroupInfo.settings ?? {}
    this.venueList = subGroupInfo.venues ?? []
    if (this.venueList && this.venueList.length > 0) {
      this.$store.commit('saveSubGroupVenueList', this.venueList)
    }
    // save to store
    this.$store.commit('saveSubgroupSetting', {
      id: this.venueSubGroupId,
      name: 'settings',
      setting: this.venueSubGroupSettings ?? {}
    })

    this.tableList = subGroupInfo.tables

    return true
  }

  async _getCartRecommend() {
    const recommendList = await otherAction({
      action: 'get_sub_group_cart_recommend',
      cart: {
        list: this.subgroupCart,
        userInfo: this.userInfo
      },
      id: this.$store.state.venueHome.subGroupId,
      groupId: '',
    }).catch((error) => {
      console.log(error)
    })
    if (recommendList && recommendList.length > 0) {
      this.recommendProductList = recommendList
    }
  }

  addProductToCart(product) {
    const singlePrice = parseFloat(product.price) + parseFloat(product?.upgradeProducts?.items?.find(item => item.checked)?.price ?? 0)
    const selectSize = {
      default: null,
      name: null,
      price: null,
      shortName: null
    }
    const unPaidOrderNo = this.$store.state.venueUnpaidOrderList.find(item => item.venueId === this.venueId)?.unPaidOrderId ?? ''
    const isAddItem = this.routerInfo.paymentType === 'post-paid' && unPaidOrderNo
    const productAdd = {
      ...product,
      // venueId: this.venueId,
      // productGroupId: null,
      isAddItem: isAddItem,
      singlePrice,
      recommendFromProductId: null,
      productGroupCourse: null,
      selectSize: selectSize,
      comboProductList: [], // This field is only used for editing products, and is not required for calling API   // 仅用于编辑商品时使用，调取 API 不需要此字段
      num: 1
    }
    // console.log(productAdd)

    // TODO: demo only - need to change to real value
    this.$store.commit('addNewProductToSubgroupCart', {
      product: productAdd,
      venueId: productAdd.venueId,
      // 按推荐品**所属**成员店取费率与判定依据：是当前店就用 app 里的，是别家店就先空着、下面补拉那家自己的设置
      // （Codex 第 2 轮 #4：以前一律存当前店的，B 店的推荐品按 A 店的附加费算）
      cartInfo: subGroupCartInfoFor(this.$store, productAdd.venueId)
    })
    this._ensureMemberSurcharges()
  }

  // 给缺判定依据的成员店补拉门店设置（不走 requestMixin，见 api/venueQuiet.js），拉到后按「现在」重判各成员店
  async _ensureMemberSurcharges() {
    const n = await ensureSubGroupSurchargeSources(this.$store, { fetchVenue: getVenueQuietly })
    if (n > 0) refreshSubGroupSurcharges(this.$store)
  }

  showAwaitTime(venue) {
    return venue.settings?.waitingTimeSettings?.enableWaitingTime
  }

  getWaitTime(venue) {
    return venue.averageWaitingTime / 60
  }

  cleanCart() {
    for (const venue of this.venueList) {
      const posStatus = venue.settings?.posStatus ?? null
      if (posStatus && posStatus.enable && posStatus.status !== 1) {
        venue.isOpen = false
        venue.posOpen = false
      } else {
        // check open time
        if (!venue.isOpen) {
          venue.isOpen = false
        }
      }
      if (!venue.isOpen) {
        // venue is not open, clean the related cart
        this.$store.commit('deleteVenueInSubGroupCart', venue.id)
      }
    }
  }
}

export default SubGroupCart
</script>
